import styled from 'styled-components';

/**
 * Estilos do card de tendência/previsão do dashboard. Reusa os estilos
 * compartilhados de `components/consumption-analysis` (Card/Table/TrendBadge);
 * aqui só o que é específico do agregado (área do grid, botão e lista de UCs).
 */
export const Container = styled.div`
  grid-area: consumptionforecast;
`;

export const ForecastButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  background-color: ${(props) => props.theme.color.ui.orange};
  color: ${(props) => props.theme.color.text.inverse};
  border: none;
  border-radius: 3px;
  font-weight: 600;
  font-size: 13px;
  padding: 8px 16px;
  cursor: pointer;

  &:disabled {
    opacity: 0.7;
    cursor: default;
  }

  &:hover:not(:disabled) {
    filter: brightness(0.95);
  }
`;

export const UnitList = styled.div`
  display: flex;
  flex-direction: column;
  margin: 4px 0 14px;
`;

export const UnitRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 7px 0;
  border-bottom: 1px dashed ${(props) => props.theme.color.ui.shade1};

  &:last-child {
    border-bottom: none;
  }
`;

export const UnitName = styled.span`
  font-size: 13px;
  color: ${(props) => props.theme.color.text.primary};
  font-weight: 600;
`;

export const TotalLine = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 10px;
  font-size: 14px;
  color: ${(props) => props.theme.color.text.primary};

  strong {
    font-size: 18px;
    color: ${(props) => props.theme.color.ui.orange};
  }
`;
